import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import InputText from '../InputText';
import { Underline } from '../../theme/InputText';
import Text from '../Text';
import QuestionSection from '../QuestionSection';

class NumericQuestion extends Component {
  state = { answerIs: null };

  componentDidMount() {
    document.addEventListener('keyup', this.keyPress, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.keyPress, false);
  }

  updateAnswer = (answerIs, answers) => this.setState({ answerIs, answers });

  keyPress = (ev) => {
    if (ev.keyCode === 13 || ev.keyCode === 9) {
      ev.preventDefault();
      this.props.checkQuestionValidity(this.props.question);
    }
  };

  render() {
    const {
      question,
      goal,
      form,
      onFocus,
      onChange,
      onBlur,
      injectNewQuestions,
      removeNewQuestions,
    } = this.props;
    return (
      <Fragment>
        {question.startText && (
          <Text type={question.textType ? question.textType : 'questionText'}>
            {parse(question.startText || '')}
          </Text>
        )}
        <InputText
          id={question.id}
          className={`question ${goal.value}`}
          autoFocus={question.index === 0 && goal.index === 0}
          name={question.inputName}
          isTextual={question.isTextual}
          onChange={(ev) => {
            form.handleChange(ev);
            form.setFieldTouched(question.inputName);
            form.validateForm(form.values);
            onChange(ev, { form, inputName: question.inputName });

            const { value } = ev.target;

            question.value = value;

            onBlur(ev, {
              values: form.values,
              goalName: goal.value,
              goalAnswered: goal.isAnswered,
              goalIndex: goal.index,
            });

            // Do we have a condition?
            if (question.condition) {
              const result = question.condition(value);
              // First time user answers this question
              if (this.state.answerIs == null) {
                this.updateAnswer(result.value, result.extraQuestions);
                injectNewQuestions(
                  result.extraQuestions,
                  goal.index,
                  question.index,
                  question.maxQuestions - result.extraQuestions.length,
                );
                // The user entered a value that resulted in a different result from the condition.
              } else if (result.value !== this.state.answerIs) {
                removeNewQuestions(
                  goal.index,
                  question.index,
                  -(question.maxQuestions - this.state.answers.length),
                  () => {
                    // Si no es la condición base
                    if (result.value !== 0) {
                      this.updateAnswer(result.value, result.extraQuestions);
                      injectNewQuestions(
                        result.extraQuestions,
                        goal.index,
                        question.index,
                        question.maxQuestions - result.extraQuestions.length,
                      );
                    } else {
                      this.updateAnswer(null, []);
                    }
                  },
                );
              }
            }
          }}
          onFocus={(ev) => onFocus(ev, question.index, goal.value, form)}
          onBlur={(ev) => {
            form.handleBlur(ev);
            onBlur(ev, {
              values: form.values,
              goalName: goal.value,
              goalAnswered: goal.isAnswered,
              goalIndex: goal.index,
            });
          }}
          value={form.values[question.inputName]}
          placeholder={question.placeholder}
          theme={Underline}
          style={
            question.inputTextStyle
              ? { maxWidth: `${question.inputMaxWidth}em`, ...question.inputTextStyle }
              : { maxWidth: `${question.inputMaxWidth}em`, fontSize: '1em', fontWeight: '300' }
          }
          maxLength={question.maxDigits}
          inputSpanWidth={question.inputSpanWidth}
          inputWidth={question.inputWidth}
          isCurrency
          autoComplete="off"
          pattern={question.pattern}
          prepend={question.prepend}
          postpend={question.postpend}
          noThousandSeparator={question.noThousandSeparator}
        />
        {question.endText && (
          <Text type={question.textType ? question.textType : 'questionText'}>
            {parse(question.endText || '')}
          </Text>
        )}
      </Fragment>
    );
  }
}

NumericQuestion.propTypes = {
  question: PropTypes.object,
  goal: PropTypes.object,
  form: PropTypes.object,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  injectNewQuestions: PropTypes.func,
  removeNewQuestions: PropTypes.func,
  goToNextInput: PropTypes.func,
  isTextual: PropTypes.bool,
};

NumericQuestion.defaultProps = {
  question: {},
  goal: {},
  form: {},
  onFocus: () => {},
  onChange: () => {},
  onBlur: () => {},
  goToNextInput: () => {},
  injectNewQuestions: () => {},
  removeNewQuestions: () => {},
  isTextual: false,
};

export default NumericQuestion;
